//////////////////////////////////
// IMPORTING MODULES
//////////////////////////////////

import { Smartphone, Cloud, Globe2 } from "lucide-react";
import React from "react";

//////////////////////////////////
// COMPONENT: DOWNLOAD
//////////////////////////////////

const Download = (): JSX.Element => {
  return (
    <section
      id="download"
      className="py-20 bg-gradient-to-b from-[#0e1220] to-[#141826]"
    >
      <div className="max-w-7xl mx-auto px-10 ">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Get Flight Trail Today
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Start tracking your travels on the go. Available now on Android.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Download Info */}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-[#2ab8ff]/20 flex items-center justify-center flex-shrink-0">
                  <Smartphone className="h-6 w-6 text-[#2ab8ff]" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    Mobile-First Experience
                  </h3>
                  <p className="text-gray-400">
                    Optimized for your phone with touch controls, landscape
                    mode, and offline support.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-[#2ab8ff]/20 flex items-center justify-center flex-shrink-0">
                  <Cloud className="h-6 w-6 text-[#2ab8ff]" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    Auto-Sync Across Devices
                  </h3>
                  <p className="text-gray-400">
                    Your travel data automatically syncs across all your devices
                    in real-time.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-[#2ab8ff]/20 flex items-center justify-center flex-shrink-0">
                  <Globe2 className="h-6 w-6 text-[#2ab8ff]" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    Beautiful 3D Globe
                  </h3>
                  <p className="text-gray-400">
                    Explore your travels on a stunning interactive globe powered
                    by Three.js.
                  </p>
                </div>
              </div>
            </div>

            {/* Download Buttons */}
            {/* ! ADD THE LINK*/}
            <div className="space-y-4">
              <a
                href="https://play.google.com/store/apps/details?id=com.flighttrail.app"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-3 w-full sm:w-auto px-8 py-4 bg-black hover:bg-gray-900 rounded-lg transition-all group border border-gray-800 hover:border-[#2ab8ff] cursor-pointer"
              >
                <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z"
                    fill="#00D9FF"
                  />
                  <path
                    d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z"
                    fill="#FFCE00"
                  />
                  <path
                    d="M20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.53 12.9 20.16 13.19L17.89 14.5L15.39 12L17.89 9.5L20.16 10.81Z"
                    fill="#FF3E4C"
                  />
                  <path
                    d="M6.05 2.66L16.81 8.88L14.54 11.15L6.05 2.66Z"
                    fill="#00F076"
                  />
                </svg>
                <div className="text-left">
                  <div className="text-xs text-gray-400">GET IT ON</div>
                  <div className="text-lg font-semibold">Google Play</div>
                </div>
              </a>

              <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
                <span>iOS version coming soon</span>
              </div>
            </div>
          </div>

          {/* Right Side - Phone Mockup */}
          <div className="relative">
            <div className="relative mx-auto" style={{ maxWidth: "300px" }}>
              {/* Phone Frame */}
              <div className="relative bg-gradient-to-br from-gray-900 to-black rounded-[3rem] p-3 shadow-2xl border-8 border-gray-800 sm:m-0 m-8">
                {/* Notch       <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-7 bg-black rounded-b-3xl z-10"></div>*/}

                {/* Screen */}
                <div className="relative bg-[#0e1220] rounded-[2.5rem] overflow-hidden aspect-[9/19.5]">
                  {/* Screenshot or Globe Preview */}
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-b from-[#0e1220] to-[#141826]">
                    <div className="">
                      <img src="/images/preview.jpeg" alt="App Preview" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating Elements */}
              {/*<div className="absolute -right-4 top-1/4 bg-[#2ab8ff]/20 backdrop-blur-sm border border-[#2ab8ff]/50 rounded-lg p-3 shadow-lg animate-pulse">
                <div className="flex items-center space-x-2">
                  <Plane className="h-4 w-4 text-[#2ab8ff]" />
                  <span className="text-sm font-semibold">Track Flights</span>
                </div>
              </div>

              <div
                className="absolute -left-4 bottom-1/4 bg-[#2ab8ff]/20 backdrop-blur-sm border border-[#2ab8ff]/50 rounded-lg p-3 shadow-lg animate-pulse"
                style={{ animationDelay: "1s" }}
              >
                <div className="flex items-center space-x-2">
                  <Map className="h-4 w-4 text-[#2ab8ff]" />
                  <span className="text-sm font-semibold">Explore World</span>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

//////////////////////////////////
// EXPORTING DOWNLOAD
//////////////////////////////////

export default Download;
